export default __webpack_public_path__ + "static/media/algodao-gray.5771af91.svg";